/**
 * The text an admin page shows when an admin request fails (TX-5165).
 *
 * The API validates admin bodies at the edge, and a refusal answers the one
 * 400 envelope: `{ error: "Invalid request", message: "Invalid request",
 * issues: [{ path, message }] }`. The reason an admin can act on is the first
 * issue's message, so that comes first. Any other failure keeps what the
 * helpers read before: the body's `error`, then its `message`, then the
 * caller's own fallback.
 *
 * Admin only. Member surfaces go through `memberErrorMessage`, which never
 * shows a schema's English text to a member.
 */
export function adminErrorMessage(body: unknown, fallback: string): string {
  if (!body || typeof body !== "object") return fallback;
  const { issues, error, message } = body as {
    issues?: unknown;
    error?: unknown;
    message?: unknown;
  };
  if (Array.isArray(issues)) {
    const first = issues[0] as { message?: unknown } | undefined;
    if (typeof first?.message === "string" && first.message.trim() !== "") {
      return first.message;
    }
  }
  if (typeof error === "string" && error.trim() !== "") return error;
  if (typeof message === "string" && message.trim() !== "") return message;
  return fallback;
}
